import type { JobRunInput, JobRunKind } from "@/features/job/job-run/jobRun.types";
import { toJobRunText } from "@/features/job/job-run/jobRun.utils";
import { JobRunImportOrderStatuses } from "./JobRunImportOrderStatuses";

/** importOrderStatuses in the run drawer. */
export const jobRunImportOrderStatuses: JobRunKind = {
  Settings: JobRunImportOrderStatuses,
  toInitialInput: (input) => {
    const initial: JobRunInput = {};
    const date = toJobRunText(input, "date");
    if (date) initial.date = date;
    return initial;
  },
  isComplete: (input) => toJobRunText(input, "date") !== "",
};
